// Minimal IndexedDB wrapper for flow drafts. IndexedDB gives hundreds of MB
// of quota (vs ~5MB for localStorage), so full workflow states live here and
// no longer crowd out the small localStorage keys.
//
// Every function resolves gracefully (null / false) when IndexedDB is
// unavailable (private mode, blocked storage) — callers treat that the same
// as a cache miss and localFlowCache's in-memory copy stays authoritative.

var DB_NAME = 'alleflow';
var STORE = 'flowDrafts';
var DB_VERSION = 1;

var dbPromise = null;

function openDb() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise(function(resolve) {
    try {
      if (typeof window === 'undefined' || !window.indexedDB) return resolve(null);
      var request = window.indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = function() {
        var db = request.result;
        if (!db.objectStoreNames.contains(STORE)) {
          db.createObjectStore(STORE, { keyPath: 'flowId' });
        }
      };
      request.onsuccess = function() { resolve(request.result); };
      request.onerror = function() { resolve(null); };
      request.onblocked = function() { resolve(null); };
    } catch (e) {
      resolve(null);
    }
  });
  return dbPromise;
}

// Runs one operation in a transaction on the drafts store; resolves fallback
// on any failure so callers never need try/catch.
function withStore(mode, run, fallback) {
  return openDb().then(function(db) {
    if (!db) return fallback;
    return new Promise(function(resolve) {
      try {
        var tx = db.transaction(STORE, mode);
        var request = run(tx.objectStore(STORE));
        request.onsuccess = function() { resolve(request.result); };
        request.onerror = function() { resolve(fallback); };
        tx.onabort = function() { resolve(fallback); };
      } catch (e) {
        resolve(fallback);
      }
    });
  });
}

// → Promise<Array<{flowId, state, dirty, updatedAt, baseUpdatedAt}>>
function getAllEntries() {
  return withStore('readonly', function(store) { return store.getAll(); }, [])
    .then(function(rows) { return Array.isArray(rows) ? rows : []; });
}

function putEntry(flowId, entry) {
  var row = Object.assign({}, entry, { flowId: String(flowId) });
  return withStore('readwrite', function(store) { return store.put(row); }, false)
    .then(function() { return true; });
}

function deleteEntry(flowId) {
  return withStore('readwrite', function(store) { return store.delete(String(flowId)); }, false)
    .then(function() { return true; });
}

module.exports = {
  getAllEntries: getAllEntries,
  putEntry: putEntry,
  deleteEntry: deleteEntry
};
